module.exports = "<div class=\"wd-skeleton wd-skeleton-default\">\n    <img src=\"\" alt=\"\" />\n</div>";